import { message } from "antd";
import { useEffect, useState } from "react";
import LtvAnalysisServices from "services/services/LtvAnalysisServices";
import { useIntl } from 'react-intl';
import { Container } from 'react-bootstrap';
import { useSearchParams } from "react-router-dom";

function PDFPage6DisclamerEdit(props: any) {
    const intl=useIntl();
    const [disclamer,SetDisclamer] = useState<any>("");
    const [loading,setLoading] = useState<any>(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const showbtn = searchParams.get("showbtn");
    
    useEffect(()=>{
        SetDisclamer(props?.disclaimer_one);
    },[props?.disclaimer_one]);

    const saveDisclamer = () => {
        let object: any = {};
        object.disclaimer_one = disclamer;

        let where: any = {};
        where.loan_id = props?.loan_id;
        setLoading(true);
        LtvAnalysisServices
        .updateLtvData(object,where)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                message.success(props.TranslateString(("Updated successfully.")));
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    }

    return (
        <>
        <Container fluid className="text-left page-break cu-pt-10">
            <div className="form-group">
                <h3 className="cu-fs-18">{props.TranslateString('Disclaimer')} : </h3>
                {
                    (()=>{
                        if(props?.isEditable){
                            return (
                                <textarea className="px-3 form-control cu-text-smaller" rows={15} onChange={(e)=>{SetDisclamer(e?.target?.value)}} value={disclamer || ""}></textarea>
                            )
                        }else{
                            return (
                                <p style={{whiteSpace:"break-spaces"}} className="p-1 border rounded cu-fs-12">
                                    {disclamer || props?.disclaimer_one}
                                </p>
                            )
                        }
                    })()
                }
            </div>
            <div className={ props?.isEditable ? `d-flex justify-content-end`:`d-none`} >
                <button className={"btn cu-btn-green btn-sm px-3 pull-right rounded-0 mt-2" + (showbtn === '0' || props?.printBtn ? ' d-none' : '') }  onClick={(e)=>{saveDisclamer()}} disabled={loading}>{loading?props.TranslateString("Please Wait"):props.TranslateString("Save")}</button>
            </div>    
        </Container>        
        </>
    );
}

export default PDFPage6DisclamerEdit;